
  import {mapSectionComponents} from '@/helper/SectionHelper';
  import {getMetaTags} from '@/helper/Seo';
  import {fixedRouteSlugs} from '@/routes.config';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'DynamicPages',
    components: {
      LazyHydrate,
    },
    layout: 'organization',
    async asyncData({route, error, $cachedStrapi}) {
      // Query page from Strapi; strapi-change for findOne is required!
      const page = await $cachedStrapi
        .findOne('pages', route.params.slug)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      if (
        !scopeHelper(page, process.env.SCOPE_ORGANIZATION) ||
        fixedRouteSlugs.includes(route.params.slug)
      ) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }

      const metaData = page && page.meta ? page.meta : {};

      const sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionSeoContent':
              if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );

      return {
        metaData,
        sections,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
      };
    },
    head() {
      const canonical_links = [];
      let canonical_url = '';

      if (this.metaData.default_canonical === 'candidate') {
        canonical_url =
          process.env.NUXT_ENV_BASE_URL +
          this.localePath({
            name: 'slug',
            params: {
              slug: this.$route.params.slug,
            },
          });
      }

      if (canonical_url) {
        canonical_links.push({
          rel: 'canonical',
          hid: 'canonical',
          href: canonical_url,
        });
      }

      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
        link: canonical_links,
      };
    },
  };
